<template lang="pug">
v-card(flat)
  v-card-text
    v-text-field(
      v-model="email",
      prepend-icon="mdi-email",
      label="Email",
      @keydown.enter="login"
    )

    v-text-field.mb-4(
      type="password",
      v-model="password",
      prepend-icon="mdi-form-textbox-password",
      label="Password",
      @keydown.enter="login"
    )

    v-btn.mb-4(block, color="primary", :loading="loading", @click="login") login

    ResetPassword(@message="message")
</template>

<script>
import ResetPassword from "./ResetPassword";

export default {
  components: { ResetPassword },

  data: () => ({
    email: "",
    password: "",
    loading: false,
  }),

  methods: {
    login() {
      this.loading = true;
      this.$auth
        .login({
          data: {
            email: this.email,
            password: this.password,
          },
        })
        .then(() => {
          this.$store.dispatch("flows/refreshFlowsList");
          this.loading = false;
        })
        .catch((e) => {
          this.$emit("error", e.response.data.Error);
          this.loading = false;
        });
    },

    message(payload) {
      const { type, text } = payload;
      this.$emit(type, text);
    }
  },
};
</script>
